// Icon
import { IconFocusCentered } from '@tabler/icons-react'

// UI
import { CameraScannerTemp as CameraScanner } from './CameraScanner'

import { useDisclosure } from '@mantine/hooks'

// Bus listener
import { useListener } from 'react-bus'

// Mantine
import { Tooltip } from '@mantine/core'

export default function CameraScannerButton({ onScan }) {
    const [opened, handlers] = useDisclosure(false)

    // Listen for event to open the scanner
    useListener('openCameraScanner', () => {
        handlers.open()
    })

    return (
        <>
            <Tooltip label="Ouvrir la caméra">
                <button
                    className="h-full px-3 bg-white hover:bg-gray-50 flex items-center justify-center"
                    onClick={handlers.open}
                >
                    <IconFocusCentered size={26} stroke={1.8} />
                </button>
            </Tooltip>

            <CameraScanner
                opened={opened}
                onClose={handlers.close}
                onScan={onScan}
            />
        </>
    )
}
